export default __webpack_public_path__ + "static/media/Icon-List-Add.96e652be.svg";